import { createApp } from 'vue';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/style.css';
import './assets/styles/fonts.css';
import App from './App.vue';
import router from './router';
import store from './index.js';
import { notificationPlugin } from './plugins/notification';

const app = createApp(App);

app.directive('tippy', {
    mounted(el, binding) {
        tippy(el, {
            content: binding.value || "Default Tooltip Content",
            delay: [1000, 1000],
            theme: 'dark',
            allowHTML: true,
        });
    }
});

app.use(router);
app.use(store);
app.use(notificationPlugin);
app.mount('#app');
